import { createEvent, createStore, sample } from 'effector'
import { useEvent, useStore } from 'effector-react'

export const onRouteChangeComplete = createEvent<string>()
export const onRouteChangeStart = createEvent<string>()
export const $routerPending = createStore(false)
export const changeRouterQuery = createEvent<object>()
export const routeInitPath = createEvent<string>()
export const $currentPath = createStore<string>('')
export const $routerQuery = createEvent<object>({})
export const $isSearchPage = createStore<boolean>(false)
export const $isBasketPage = createStore<boolean>(false)
export const $isPromotionPage = createStore<boolean>(false)
export const $isCatalogPage = createStore<boolean>(false)
export const $isLikedPage = createStore<boolean>(false)

export const setPageState = createEvent<{
    isCatalogPage: boolean
    isSearchPage: boolean
}>()

sample({
    clock: changeRouterQuery,
    target: $routerQuery
})

sample({
    clock: setPageState,
    fn: ({ isCatalogPage }) => isCatalogPage,
    target: $isCatalogPage
})

sample({
    clock: setPageState,
    fn: ({ isSearchPage }) => isSearchPage,
    target: $isSearchPage
})

sample({
    clock: onRouteChangeStart,
    fn: () => true,
    target: $routerPending
})

sample({
    clock: onRouteChangeComplete,
    fn: () => false,
    target: $routerPending
})

sample({
    clock: onRouteChangeComplete,
    target: $currentPath
})

sample({
    clock: $currentPath,
    filter: (path) =>
        path.includes('/catalog') &&
        !path.includes('/catalog/search') &&
        !path.includes('/catalog/liked') &&
        !path.includes('/catalog/promotion'),
    fn: () => true,
    target: $isCatalogPage
})

sample({
    clock: $currentPath,
    filter: (path) => path.includes('/catalog/search'),
    fn: () => true,
    target: $isSearchPage
})

sample({
    clock: $currentPath,
    filter: (path) => path.includes('/order/basket'),
    fn: () => true,
    target: $isBasketPage
})

sample({
    clock: $currentPath,
    filter: (path) => path.includes('/catalog/promotion'),
    fn: () => true,
    target: $isPromotionPage
})

sample({
    clock: $currentPath,
    filter: (path) => path.includes('/catalog/liked'),
    fn: () => true,
    target: $isLikedPage
})

sample({
    clock: routeInitPath,
    target: $currentPath
})

export const useOnRouteChangeComplete = () => useEvent(onRouteChangeComplete)
export const useOnRouteChangeStart = () => useEvent(onRouteChangeStart)
export const useRouteInitPath = () => useEvent(routeInitPath)
export const useCatalogSearch = () => useStore($isSearchPage)
export const useChangeRouterQuery = () => useEvent(changeRouterQuery)
